module.exports = __webpack_public_path__ + "img/vegetable-purslane-350x184.ea4cafae.jpg";